// angular
import { NgClass } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { ActivatedRoute, Params, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'pwj-section-bar',
  standalone: true,
  imports: [TranslateModule, NgClass, RouterLink],
  templateUrl: './section-bar.component.html',
  styleUrl: './section-bar.component.scss'
})
export class SectionBarComponent {
  public params!: Params;
  // inputs
  icon = input<string | null>(null);
  link = input<string | null>(null);
  barTitle = input.required<string>();
  dataTitle = input.required<string>();
  dataCount = input.required<number>();

  // dependencies
  private readonly _activatedRoute = inject(ActivatedRoute);

  constructor() {
    this._activatedRoute.queryParams.subscribe(params => {
      // check if search item is valid then call api
      if (params?.['search']) {
        this.params = {
          search: params?.['search'],
        };
      }
    });
  }
}
